module.exports = __webpack_public_path__ + "img/video-placeholder.6d2e8e05.png";